"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadScript = loadScript;
exports.loadStyle = loadStyle;

/**
 * @file 加载 script css 模块
 * @author qiaogang
 * @date 2019-11-19
 */
function createEl(tagName, attr) {
  return new Promise(function (resolve, reject) {
    var tag = document.createElement(tagName);

    tag.onload = function () {
      resolve({
        code: 0,
        msg: 'ok'
      });
    };

    tag.error = function () {
      reject({
        code: 1,
        msg: "".concat(tagName, " tag load error.")
      });
    };

    for (var attrKey in attr) {
      if (attr.hasOwnProperty(attrKey)) {
        var val = attr[attrKey];
        tag.setAttribute(attrKey, val);
      }
    }

    var headEl = document.getElementsByTagName('head')[0];

    if (headEl) {
      headEl.appendChild(tag);
    } else {
      reject({
        code: 2,
        msg: "".concat(tagName, " tag can't appendTo head tag.")
      });
    }
  });
}

function loadScript(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createEl('script', {
    src: url
  });
}

function loadStyle(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createEl('style', {
    link: url
  });
}